import NonEditableBlock from './base/non-editable-block';
import { computed } from '@ember/object';
import { htmlEscape, ternaryToProperty } from '@intercom/pulse/lib/computed-properties';
import openingTag from './../../lib/computed-properties/ic-block-opening-tag';
import uriComponentEncode from '@intercom/embercom-composer/lib/computed-properties/uri-component-encode';
import { not, or } from '@ember/object/computed';
import Em from 'ember';
export default NonEditableBlock.extend({
  type: 'twitterFollowButton',
  isMedia: true,
  isTwitterFollowButton: true,
  isValid: true,
  isNotAllowSocial: not('config.allowSocial'),
  isLinkOnlyMode: or('isNotAllowSocial', 'config.displaySocialBlocksAsButtons'),
  openingTag: openingTag('username', 'id', 'isLinkOnlyMode'),
  closingTag: '</ic-block>',
  innerHtml: computed('_zeroWidthSpace', '_paragraphInserter', 'iframeOrLinkHtml', function () {
    return `${this._zeroWidthSpace}${this._paragraphInserter}<span contenteditable="false">${this.iframeOrLinkHtml}</span>${this._paragraphInserter}${this._zeroWidthSpace}`;
  }),
  encodedUsername: uriComponentEncode('username'),
  htmlEscapedUsername: htmlEscape('username'),
  iframeOrLinkHtml: ternaryToProperty('isLinkOnlyMode', 'linkHtml', 'iframeHtml'),
  linkHtml: computed('htmlEsacepdUsername', function () {
    return `<a class="link-only-mode intercom-h2b-button" href="https://twitter.com/${this.htmlEscapedUsername}"><i></i>Follow us on Twitter</a>`;
  }),
  iframeHtml: computed('encodedUsername', function () {
    return `<iframe src="https://platform.twitter.com/widgets/follow_button.html?screen_name=${this.encodedUsername}&amp;show_screen_name=true&amp;show_count=false" class="block-iframe" scrolling="no" frameborder="0" allowtransparency="true"></iframe>`;
  }),
  serialized: Em.computed('type', 'username', function () {
    return {
      type: this.get('type'),
      username: this.get('username')
    };
  }),
  cleanUsername: Em.on('init', Em.observer({
    dependentKeys: ['username'],
    fn() {
      let username = this.get('username') || '';
      let match = username.match('(?:https?:)//(?:www.)?twitter.com/(.+)');
      if (match) {
        this.set('username', match[1]);
      }
    },
    sync: true
  }))
});